import { ButtonProps } from 'antd';
import { useAccess } from 'umi';
import CssBtn from '@/components/CssBtn';

type AccessButtonProps = {
    accessKey: string;
    children: React.ReactNode;
} & ButtonProps;

const AccessButton: React.FC<AccessButtonProps> = ({
    accessKey,
    children,
    disabled,
    ...rest
}) => {
    const access = useAccess();
    return (
        <CssBtn
            // style={{ transition: 'none' }}
            type="link"
            size="middle"
            {...rest}
            disabled={!access?.buttonAccess?.(accessKey) || disabled}
            // 保证disable样式统一
            style={access?.buttonAccess?.(accessKey) && !disabled && rest.style}
        >
            {children}
        </CssBtn>
    );
};

export default AccessButton;
